import { useContext, useSyncExternalStore } from 'react';
import { buildCarouselCards } from '../constants/homeData';
import { TranslationContext } from '../contexts/translationContext';
import {
  getCards,
  getCardsSnapshot,
  getCardNameOverrides,
  getCardStyleOverrides,
  refreshCards,
  subscribeCardUpdates,
} from '../services/cards';

export function useUserCard() {
  useSyncExternalStore(
    subscribeCardUpdates,
    getCardsSnapshot,
    getCardsSnapshot
  );

  return getCards()[0] ?? null;
}

export function useCarouselCards() {
  const { card } = useContext(TranslationContext);

  useSyncExternalStore(
    subscribeCardUpdates,
    getCardsSnapshot,
    getCardsSnapshot
  );

  return buildCarouselCards(getCards(), getCardNameOverrides(), getCardStyleOverrides(), card);
}

export function useCardsState() {
  return useSyncExternalStore(
    subscribeCardUpdates,
    getCardsSnapshot,
    getCardsSnapshot
  );
}

export { refreshCards };
